var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 16.9216C17.24 16.9216 16.56 17.2228 16.04 17.6946L8.91 13.5285C8.96 13.2976 9 13.0667 9 12.8258C9 12.5849 8.96 12.354 8.91 12.1231L15.96 7.9972C16.5 8.49913 17.21 8.81033 18 8.81033C19.66 8.81033 21 7.46515 21 5.79872C21 4.1323 19.66 2.78711 18 2.78711C16.34 2.78711 15 4.1323 15 5.79872C15 6.03965 15.04 6.27054 15.09 6.50143L8.04 10.6273C7.5 10.1254 6.79 9.8142 6 9.8142C4.34 9.8142 3 11.1594 3 12.8258C3 14.4922 4.34 15.8374 6 15.8374C6.79 15.8374 7.5 15.5262 8.04 15.0243L15.16 19.2004C15.11 19.4112 15.08 19.6321 15.08 19.8529C15.08 21.4691 16.39 22.7842 18 22.7842C19.61 22.7842 20.92 21.4691 20.92 19.8529C20.92 18.2367 19.61 16.9216 18 16.9216Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkShare);
export default __webpack_public_path__ + "static/media/linkShare.9c8a105574935572c9b1263a482363a7.svg";
export { ForwardRef as ReactComponent };